import * as validators from '~/utils/validators';

export const isValidUrl = (value: string) => validators.urlValidator.isValidSync(value);
